import React, { Component } from "react";
import { connect } from "react-redux";
import "clientjs";
import { TicketApi } from "services/ticket";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { Utils } from "services/utils";
import { RESOLUTIONS } from "services/config";
import { SelectionScreen } from "styled_components/Feedback/SelectionScreen";
import { DescriptionScreen } from "styled_components/Feedback/DescriptionScreen";
import { ConfirmationScreen } from "styled_components/Feedback/ConfirmationScreen";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const headerImageDefault = `${CDN_URL}common/feedback/chat-bubble-default.svg`;

const SUBTITLE = {
  SELECTION: "Send us your Feedback",
  DESCRIPTIONBUG: "Tell us about this bug.",
  DESCRIPTIONIDEA: "Tell us about your idea.",
  DESCRIPTIONLIKE: "Tell us more about what you like.",
  CONFIRMATION: "Confirmation",
};

class FeedbackModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedScreen: "SELECTION",
      selectedType: null,
      module: null,
      error: null,
      attachment: null,
      attachmentError: null,
      attachmentLoading: false,
      description: "",
    };
  }

  componentDidMount() {
    const { site } = this.props;
    this.setState({ module: site.module });
    this.getTicketType();
  }

  FormatDescription = (description, browserInfo) => {
    const { site, auth_status, company_info } = this.props;
    const userId = auth_status.user.id;
    const companyId = company_info?.customer?.idd;
    let desc = description;
    desc = `Description: ${desc}`;
    desc += `Requestor: ${userId}  \n`;
    desc += `Company: ${companyId}  \n`;
    desc += `Location: ${site?.page}  \n`;

    // Adding shared user information if available
    const sharedUserData = sessionStorage.getItem("sharedUser");
    if (sharedUserData) {
      const { name, email } = JSON.parse(sharedUserData);
      desc += `Shared User Name: ${name}  \n`;
      desc += `Shared User Email: ${email}  \n`;
    }

    desc += `Browser Information: ${browserInfo}  \n`;
    return desc;
  };

  getTicketType = () => {
    TicketApi.getTicketType("feedback")
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          this.setState({ ticketType: response?.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  submitTicket = async () => {
    const { selectedType, attachment, description } = this.state;
    const {
      site,
      auth_status,
      auth_status: {
        user: {
          userProfile: { emailAddress },
        },
      },
      company_info,
      showModal,
    } = this.props;
    const browserInfo = await Utils.getClientParams(site);

    const userId = auth_status.user.id;
    const companyId = company_info?.customer?.id;

    const ticket = {
      requester: Utils.getRequester(auth_status),
      requester_contact_type: "",
      requester_contact_value: emailAddress,
      internalTicketReference: "",
      invite_id: "",
      record_id: "",
      requester_id: userId,
      public_request: null,
      status: "New",
      title: "Feedback",
      description,
      priority: "low",
      internal_priority: "low",
      type: "Feedback",
      request_type: "Feedback",
      request_method: "portal",
      service: site?.module,
      process_id: 0,
      companyId,
      userId,
      jira_ticket: "",
      location: site?.page,
      impact_to_customer: "None",
      impact_to_dcblox: "None",
      resolution_notes: "",
      general_support_question_type: "",
      general_support_question: "",
      general_support_equipment: "",
      feedback_type: selectedType,
      feedback_jira_ticket: "",
      feedback_browser_data: browserInfo,
      billing_detail: [],
      outage_details: [],
      related_tickets: [],
      assignes: [],
      request_log: [],
      comments: [],
      attachments: attachment ? [attachment] : [],
      notifications: [],
      related_services: [],
      test_results: [],
    };
    TicketApi.createTicket(ticket)
      .then((response) => {
        if (
          response.status === 200 &&
          response.data.caseId &&
          !response.data.error
        ) {
          sessionStorage.removeItem("tickets");
          this.setState({ selectedScreen: "CONFIRMATION", error: null });
        } else {
          this.setState({
            selectedScreen: "CONFIRMATION",
            error: response.data.error,
          });
        }
        setTimeout(() => {
          showModal();
        }, 3000);
      })
      .catch((error) => {
        setTimeout(() => {
          showModal();
        }, 3000);
        this.setState({ selectedScreen: "CONFIRMATION", error: error.message });
      });
  };

  onSubmit = () => {
    this.submitTicket();
  };

  componentDidUpdate(prevProps) {
    const { site } = this.props;
    if (prevProps.site.module !== site.module) {
      this.setState({ module: site.module });
    }
  }
  onSelect = (selectedType) => {
    this.setState({ selectedType, selectedScreen: "DESCRIPTION" });
  };

  recieveAttachment = (attachment, error) => {
    if (attachment && !error) {
      this.setState({ attachment, attachmentLoading: false });
    } else {
      this.setState({ attachmentError: error, attachmentLoading: false });
    }
  };

  setLoading = () => {
    this.setState({ attachmentLoading: true });
  };

  getScreen = (selected) => {
    const {
      selectedType,
      module,
      error,
      attachment,
      attachmentError,
      attachmentLoading,
      description,
    } = this.state;
    const { breakpoint } = this.props;

    let Screen;
    switch (selected) {
      case "SELECTION":
        Screen = SelectionScreen;
        break;
      case "DESCRIPTION":
        Screen = DescriptionScreen;
        break;
      case "CONFIRMATION":
        Screen = ConfirmationScreen;
        break;
      default:
        Screen = SelectionScreen;
        break;
    }
    return (
      <Screen
        onSelect={this.onSelect}
        selectedType={selectedType}
        module={module}
        breakpoint={breakpoint}
        onSubmit={this.onSubmit}
        error={error}
        sendAttachment={this.recieveAttachment}
        attachment={attachment}
        attachmentError={attachmentError}
        attachmentLoading={attachmentLoading}
        setLoading={this.setLoading}
        setDescription={this.setDescription}
        description={description}
      />
    );
  };
  getSize = (breakpoint) => {
    let size = "medium";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };

  getSubTitle = (selectedScreen, selectedType) => {
    if (selectedScreen === "SELECTION") {
      return SUBTITLE[selectedScreen];
    } else if (selectedScreen === "DESCRIPTION") {
      return SUBTITLE[`${selectedScreen}${selectedType}`];
    }
  };

  setDescription = (description) => {
    this.setState({ description });
  };

  render() {
    const { selectedScreen, selectedType, description, attachmentLoading } =
      this.state;
    const { showModal, breakpoint } = this.props;
    const enabled = !!(
      description &&
      description.length >= 1 &&
      !attachmentLoading
    );

    return (
      <div className="feedback-modal-wrapper" id="feedback-modal-wrapper">
        <PortraitModalComponent
          closeModal={() => {
            this.setState({ description: "" });
            showModal();
          }}
          show={() => showModal()}
          header={
            <ModalHeader
              image={headerImageDefault}
              text={""}
              className="guest"
            />
          }
          title="Feedback"
          subTitle={this.getSubTitle(selectedScreen, selectedType)}
          size={this.getSize(breakpoint)}
          breakpoint={breakpoint}
        >
          {this.getScreen(selectedScreen)}
          <ModalFooter
            cypressId="footer"
            id="footer"
            buttonText1={"Submit"}
            buttonText2="Back"
            buttonActive1={enabled}
            buttonActive2={true}
            module="account"
            buttonFunction1={
              selectedScreen === "DESCRIPTION" ? this.onSubmit : null
            }
            size={this.getSize(breakpoint)}
            //buttonFunction2={}
          />
        </PortraitModalComponent>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site_tracking,
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps, null)(FeedbackModal);
